import http from '@/api/http';
import { serialize } from '@/utils/format';

export async function listCompany(token) {

    try {

        // console.log(query);

        const response = await http.get('api/v1/company/list',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function getCompany(token, id) {

    try {

        // console.log(query);

        const response = await http.get('api/v1/company?id=' + id,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}


export async function updateCompany(token, data) {
    try {
        let dataPram = {
            'title': data.title,
            'description': data.description,
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        const response = await http.post('api/v1/company',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function archCompany(token, id) {
    try {
        let dataPram = {
            'id': id
        }

        const response = await http.post('api/v2/archive/company', 
            dataPram,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function delCompany(token, id) {
    try {
        const response = await http.delete('api/v1/company?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function inviteCode(token, data) {
    try {
        let dataPram = {
            'id': data.id,
            'role': data.role,
        }

        const response = await http.get('api/v1/company/link-code?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function sendInvitation(token, data) {
    try {
        let dataPram = {
            'code': data.code
        }

        const response = await http.post('api/v1/role/add-key',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            }
        )

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}